/**
 * This reducer is used for product search and quick orders
 */
import {
    GET_PRODUCTS,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILURE,
    GET_PRODUCTS_BULK,
    GET_PRODUCTS_BULK_SUCCESS,
    GET_PRODUCTS_BULK_FAILURE,
    CLEAR_PRODUCTS,
} from '../actions';

const initialState = {
    products: [],
    queryParams: {
        orderType: '',
        pageLimit: 50,
        pageNum: 0,
        searchParam: '',
        searchTerm: '',
        cancelSearchToken: '',
    },
    totalRecordsCount: 0,
    loading: false,
    isBulkUpload: false,
    statusCode: 0,
    statusMessage: '',
};

const productsSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRODUCTS:
            return {
                ...state,
                queryParams: { ...state.queryParams, ...action.payload },
                loading: true,
                isBulkUpload: false,
            };
        case GET_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.products,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                totalRecordsCount: action.totalRecordsCount,
                loading: false,
                isBulkUpload: false,
            };
        case GET_PRODUCTS_FAILURE:
            return {
                ...state,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                totalRecordsCount: 0,
                loading: false,
                isBulkUpload: false,
            };
        case CLEAR_PRODUCTS:
            return initialState;
        case GET_PRODUCTS_BULK:
            return {
                ...state,
                products: [],
                loading: true,
                isBulkUpload: true,
            };
        case GET_PRODUCTS_BULK_SUCCESS:
            return {
                ...state,
                products: action.products,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
                isBulkUpload: true,
            };
        case GET_PRODUCTS_BULK_FAILURE:
            return {
                ...state,
                products: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
                isBulkUpload: true,
            };

        default: {
            return { ...state };
        }
    }
};

export default productsSearchReducer;
